import { useNavigate } from "react-router-dom";
import { handleRedirect } from "../../../utils/CommonFunctions";
import { ReactComponent as LocationIcon } from "../assets/location.svg";
import { AddressObject } from "../context/RecoEngineContext";
import { createGoogleMapsLink } from "../services";

interface AddressProps {
  name: string;
  address: AddressObject;
}

const Address = ({ name, address }: AddressProps) => {
  const history = useNavigate();
  
  // Build address1 with proper comma handling
  const streetParts = [address.street1, address.street2].filter(part => part && part.trim() !== "");
  const address1 = streetParts.join(", ");
  
  // Build address2 with proper comma handling
  const address2Parts = [address.city, address.province, address.postal_code].filter(part => part && part.trim() !== "");
  const address2 = address2Parts.join(", ");

  const addressLink = createGoogleMapsLink(`${address1}, ${address2}`)

  return (
    <div className="recoEngine__address">
      <LocationIcon />
      <button 
        type="button" 
        onClick={() => handleRedirect({type: "URL", url: addressLink}, history, `Address - ${name}`, "RECO_ENGINE")} 
        className="address_text"
        aria-label={`Open ${name} location in Google Maps`}
      >
        {address1 !== "" && <p>{address1}</p>}
        {address2 !== "" && <p>{address2}</p>}
      </button>
    </div>
  );
};

export default Address;
